export default __webpack_public_path__ + "static/media/milluu-riskfree.7df63e95.svg";